export default function CounterChip({
  label,
  count,
}: {
  label: string;
  count: number;
}): JSX.Element {
  return (
    <dl className="flex mr-2">
      <dt className="text-lg mr-2">{label}:</dt>
      <dd className="text-xl font-bold">{count}</dd>
    </dl>
  );
}
